export default class Router
  @parkReservation = (base, park, service, date, time) ->
    prefix = "#{base}/#{park.uid}::reserve"
    serviceStr = if service then service.id else 'NA'
    dateStr = moment(date).format('YYYY-MM-DD') if date
    timeStr = null
    url = _.compact([prefix, serviceStr, dateStr, timeStr]).join(':')
    url
